import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params.modifiedModel)([]);

export default { onAfterSave };
